export const createShortName = (person, placeholder = '') => {
  if (!person) return placeholder;

  const { firstName, patrName, surName } = person;
  const initials = createInitials(firstName, patrName);
  return [surName?.trim(), initials].filter(Boolean).join(' ');
};

function charToUpperCase(char) {
  return char?.toUpperCase();
}

function createInitials(...args) {
  const parts = args.map((el) => charToUpperCase(el?.[0])).filter(Boolean);
  return parts.length ? parts.join('. ') + '.' : '';
}
